import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { vals } from "@/lib/format";

const KEY = "orbit_bank_seen";
const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
const beep = () => { try { const c = new (window.AudioContext || window.webkitAudioContext)(); const o = c.createOscillator(); const g = c.createGain(); o.connect(g); g.connect(c.destination); o.frequency.value = 880; g.gain.value = 0.08; o.start(); o.stop(c.currentTime + 0.18); } catch { /* no audio */ } };

export function BankAlerts() {
  const { view, staff, t, money, loaded } = useApp();
  const nav = useNavigate();
  const seen = useRef(load());
  const first = useRef(true);
  useEffect(() => {
    if (!loaded || staff?.role !== "owner") return;
    const moves = vals(view.bank_moves).filter((m) => m.transfer_id);
    const fresh = [];
    for (const m of moves) {
      const state = m.voided ? "cancelled" : m.status || "completed";
      const prev = seen.current[m.id];
      if (prev !== state) { seen.current[m.id] = state; if (!first.current) fresh.push({ m, state, prev }); }
    }
    first.current = false;
    localStorage.setItem(KEY, JSON.stringify(seen.current));
    for (const { m, state, prev } of fresh) {
      const go = { label: t("virtual_bank"), onClick: () => nav("/bank") };
      if (m.source === "transfer_in" && state === "hold") { beep(); toast.info(`${t("bank_alert_incoming")} · ${money(m.amount)}`, { description: m.note, duration: 15000, action: go, id: `bank-${m.id}` }); }
      else if (state === "completed" && prev === "hold") toast.success(`${t("bank_alert_completed")} · ${money(m.amount)}`, { description: m.note, duration: 10000, action: go, id: `bank-${m.id}` });
      else if (state === "cancelled" && prev === "hold") toast.warning(`${t("bank_alert_cancelled")} · ${money(m.amount)}`, { description: m.note, duration: 10000, action: go, id: `bank-${m.id}` });
    }
  }, [view.bank_moves, staff, loaded]); // eslint-disable-line
  return null;
}
